// TimeZoneDropdown.js
import React, { useMemo } from "react";
import { TreeSelect } from "primereact/treeselect";
import "./style.scss";
import { ProgressSpinner } from "primereact/progressspinner";
const TimeZoneDropdown = ({
  timezones,
  value,
  onChange,
  disabled,
  className,
  error,
  loading = false,
  placeHolder,
}) => {
  const groupedTimezones = useMemo(() => {
    const groups = {};

    timezones.forEach((tz) => {
      const continent = tz.value.split("/")[0] || "Other";
      if (!groups[continent]) groups[continent] = [];

      groups[continent].push({
        key: tz.value,
        label: tz.name,
        selectable: true,
      });
    });

    return Object.entries(groups).map(([continent, children]) => ({
      key: continent,
      label: continent,
      selectable: false,
      children,
    }));
  }, [timezones]);

  return (
    <div
      className={`w-full relative timezone_dropdown ${loading ? "loader__active" : ""}`}
    >
      <TreeSelect
        value={value}
        options={groupedTimezones}
        onChange={(e) => onChange(e.value)}
        selectionMode="single"
        placeholder={placeHolder ? placeHolder : "Select your time zone"}
        disabled={disabled}
        className={`w-full ${className || ""}`}
        panelClassName="timezone-panel"
        filter
      />
      {loading && (
        <div className="loading-overlay">
          <ProgressSpinner />
        </div>
      )}
      {error && <small className="error-message">{error.message}</small>}
    </div>
  );
};

export default TimeZoneDropdown;
